/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable arrow-parens */
/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Header = styled.div`
  height: 30vh;
  width: 90%;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin: 0px auto 20px;

  div.challenges {
    /* width: 70%; */
    /* height: 100px; */
    color: #fff;
    font-weight: bold;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    div.support-scorecard {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      div.scorecard {
        height: 130px;
        width: 100%;
        margin-left: 10px;

        background: #28316c;
        border-radius: 5px;

        padding: 20px;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      div.flag {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

      div.detail {
        height: 130px;
        width: 220px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        margin: 0 5px;

        background: #28316c;
        border-radius: 5px;

        div.image {
          position: relative;
          left: -70px;
          width: 35px;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          text-align: center;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          margin-bottom: 15px;
          img {
            width: 25px;
          }
        }

        p {
          font-size: 20px;
        }
        div.subDetail {
          text-align: center;

          margin: 0 20px;

          p {
            font-size: 16px;
          }

          div.n {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 150px;

            p.number {
              font-size: 50px;
              font-weight: bold;
            }
            div {
              p {
                font-size: 18px;
                color: #aaa;
              }
            }
          }
        }
      }
    }
  }

  div.apollo {
    width: 20%;
    height: 100px;
    color: #fff;
    font-weight: bold;

    button.levels {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background-color: #28316c;
      padding: 10px;
      padding-left: 20px;
      padding-right: 20px;
      margin-top: 5px;
      border-radius: 5px;
      height: 150px;
      width: 200px;
      color: #fff;
      font-weight: bold;
      border: none;

      div.support {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          width: 100px;
          height: 100px;
        }

        p {
          font-size: 18px;
        }
      }

      ${(props) =>
        props.selected &&
        css`
          background: #090f35;
          width: 180px;
          height: 70px;
          color: #fff;
        `}
    }
  }
`;

export const Body = styled.div`
  width: 90%;
  height: 70vh;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin: 50px auto 0px;

  /* padding-bottom: 20px; */
  /* padding-left: 30px; */

  div.modules {
    /* display: grid;
    grid-template-columns: 150px 150px 150px;
    grid-row-gap: 40px;
    grid-column-gap: 40px; */

    color: #fff;
    font-weight: bold;

    width: 20%;
    height: 500px;

    margin-left: 30px;

    div.supportCards {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      overflow-x: auto;
      padding-top: 15px;
      height: 50vh;

      div.card {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 150px;
        height: 150px;
        padding: 10px;
        margin: 10px;
        border-radius: 5px;
        background: #28316c;

        img {
          width: 130px;
          height: 80px;
          border-radius: 5px;
          margin-bottom: 5px;
        }

        img.medal {
          position: relative;
          left: 50px;
          top: -30px;
          width: 50px;
          height: 50px;
        }

        p {
          color: #fff;
          text-align: center;
          margin-top: -30px;
          font-size: 14px;
        }
      }
    }
  }

  div.jobs {
    color: #fff;
    font-weight: bold;

    width: 75%;
    height: 500px;

    div.support1 {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 10px;
      overflow-x: auto;
      padding-top: 15px;
      div.approved {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        background: #28316c;
        color: #666;
        width: 250px;
        border-radius: 5px;
        margin-right: 10px;
        height: 100px;
        p {
          line-height: 20px;
          width: 150px;
          color: #fff;
          text-align: right;
        }
        img {
          width: 60px;
          height: 60px;
          border-radius: 5px;
          margin: 10px;
        }
      }
    }
  }

  div.noModules {
    border: 0.5px dashed #ddd;
    border-radius: 5px;
    width: 90%;
    height: 80%;
    margin-top: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    button {
      margin: 5px 0 0;
      width: 180px;
      height: 50px;
      background: #36ded6;
      font-weight: bold;
      color: #090f35;
      border: 0;
      border-radius: 5px;
      font-size: 14px;
      transition: background 0.2s;
      margin-top: 20px;

      &:hover {
        background: ${darken(0.08, '#36ded6')};
      }
    }
  }
`;

export const CloseModal = styled.button`
  position: absolute;
  width: 95.5%;
  height: 105.5vh;
  margin-left: -4px;
  background: rgba(44, 51, 91, 0.6);
  border: none;
`;

export const Modal = styled.div`
  position: absolute;
  top: 110px;
  bottom: 100px;
  left: 100px;
  right: 100px;

  width: 80%;
  height: 70%;
  border-radius: 10px;
  background: #090f35;

  z-index: 3;

  h1 {
    color: #fff;
    margin-top: 30px;
  }

  h2 {
    color: #fff;
  }

  div.support {
    /* display: flex;
    flex-direction: row;
    justify-content: space-around; */
    padding: 40px;

    table {
      table-layout: fixed;
      background: #fff;
      border-collapse: collapse;
      border-radius: 10px;

      tr {
        th {
          width: 200px;
          /* border: 1px solid #aaa; */
          img {
            width: 120px;
            height: 120px;
          }
        }
        th:first-child {
          img {
            width: 40px;
            height: 40px;
          }
        }
        td {
          border-left: 1px solid #ddd;
          border-top: 1px solid #ddd;
          height: 75px;
          font-size: 18px;
        }
        td:first-child {
          font-size: 18px;
          font-weight: bold;
          color: #36ded6;
        }
      }
    }
  }
`;

export const ViewToolTip = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 200px;
  height: 100px;
  margin-left: 20px;
  margin-top: -20px;
  padding: 10px;

  background: #090f35;
  border: 3px solid #36ded6;
  border-radius: 5px;
  color: #fff;

  p {
    margin-top: 5px;
    margin-bottom: 5px;
    text-align: center;
    font-size: 16px;
  }

  &::before {
    content: '';
    position: absolute;
    /* right: 12px; */
    left: 5px;
    top: -3px;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #36ded6;
  }
`;

export const ViewToolTipChallenge = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
  width: 200px;
  height: 100px;
  margin-left: 20px;
  margin-top: 20px;
  padding: 10px;

  background: #090f35;
  border: 3px solid #36ded6;
  border-radius: 5px;
  color: #fff;

  p {
    margin-top: 5px;
    margin-bottom: 5px;
    text-align: center;
    font-size: 16px;
  }

  &::before {
    content: '';
    position: absolute;
    right: -18px;
    /* left: 5px; */
    top: 10px;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 15px solid #36ded6;
  }
`;
